// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'upload';

export const Component = () => (
  <path d='M2.048 20.86h20.498c.027 0 .048.022.048.049v1.82a.047.047 0 0 1-.048.047H2.048A.047.047 0 0 1 2 22.728v-1.82c0-.026.021-.047.048-.047ZM16.463 8.499l-3.181-3.155V17.7c0 .59-.38.968-.971.968-.613 0-1.019-.368-1.019-.968V5.345L8.111 8.513c-.144.25-.416.347-.743.347-.591 0-.971-.378-.971-.968 0-.26.101-.494.287-.68l4.895-4.924.129-.093c.263-.13.434-.195.603-.195.15 0 .248.041.555.195l.13.093 4.895 4.925c.186.185.287.42.287.68 0 .589-.38.968-.971.968-.31 0-.58-.114-.745-.362Z' />
);

export const viewBox = '0 0 25 25';
